import { cva } from 'class-variance-authority'

export const teaserCardGroupGridVariants = cva('w-full', {
  variants: {
    size: {
      mini: 'grid grid-cols-[repeat(auto-fill,minmax(calc(100%/4-10px),1fr))] gap-[10px] md:grid-cols-[repeat(auto-fill,minmax(calc(100%/6-14px),1fr))] md:gap-[14px] lg:grid-cols-[repeat(auto-fill,minmax(calc(100%/8-14px),1fr))] lg:gap-[14px]',
      small:
        'grid grid-cols-[repeat(auto-fill,minmax(calc(100%/2-22px),1fr))] gap-x-5.5 gap-y-12.5 md:gap-y-17.5 md:gap-x-10.5 sm:grid-cols-[repeat(auto-fill,minmax(calc(100%/4-22px),1fr))] md:grid-cols-[repeat(auto-fill,minmax(calc(100%/4-42px),1fr))]',
      medium:
        'flex flex-wrap sm:grid justify-center sm:grid-cols-[repeat(auto-fill,minmax(calc(33.33%-30px),1fr))] lg:grid-cols-[repeat(auto-fill,minmax(calc(33.33%-60px),1fr))] gap-[50px] lg:gap-[60px]',
      large: [
        'flex flex-wrap sm:grid sm:gap-[30px] lg:gap-[60px]',
        'sm:grid-cols-[repeat(auto-fill,minmax(calc(50%-60px),1fr))] sm:px-7.5 md:px-[6.875rem]',
      ],
    },
  },
})
